<div class="max-w-2xl mx-auto py-10 px-5 text-center">
  <!-- Logo e Pulsante Azienda -->
  <div class="flex justify-around items-center">
    <img src="images/logo-drfeel-gradient.svg" alt="Logo Dr.Feel" />
    <!-- <button class="bg-gray-900 text-sm px-4 py-2 rounded-lg">
      LOGO AZIENDA
    </button> -->
    <img src="images/logo_ambassador.png" alt="Ambassador-Program" class="max-h-10" />
  </div>

  <div>
    <!-- Prima immagine -->
    <div class="my-12 flex items-center justify-center text-[#535353] font-bold">
      <img src="images/screen_mockup.png" alt="screenmockup" />
    </div>

    <!-- Testo Descrittivo -->
    <div class="text-start my-5">
      <h2 class="text-5xl font-bold text-drfeel">La tua salute su misura</h2>
      <p class="text-gray text-lg my-2 leading-[24px]">
        Un team di medici, professionisti del benessere e servizi innovativi
        dedicati a te, 7 giorni su 7, sempre e ovunque.
      </p>
      <p class="text-darkGray font-bold">
        Per attivare Dr.Feel è semplicissimo. Clicca e segui tutte le
        istruzioni. In pochi minuti, potrai accedere alla tua nuova esperienza
        di salute.
      </p>
    </div>

    <div class="my-[55px]">
      <button (click)="completeOnboarding()"
        class="bg-drfeel py-4 px-14 rounded-[5px] text-white text-[18px] uppercase font-bold">
        Attiva il servizio
      </button>
    </div>

    <!-- Note -->
    <div class="rounded-2xl bg-pink text-drfeel py-5 px-7 text-start">
      <h3 class="uppercase text-lg font-semibold">Importante</h3>
      <p class="text-base">
        Per registrarsi è obbligatorio seguire i passaggi. Non registrarti
        direttamente dall’app.
      </p>
    </div>

    <!-- Descrizione Abbonamento -->
    <div class="text-start mt-20">
      <h3 class="text-drfeel text-base uppercase font-bold">Come Funziona?</h3>
      <p class="text-base">
        E’ semplice. Scoprilo nella
        <a href="https://drfeel.com/come-funziona.html" target="_blank" class="underline">sezione dedicata sul sito di
          Dr.Feel</a>
      </p>
      <p class="text-drfeel my-3">
        <a href="https://www.youtube.com/watch?v=OYa_y9vscN4" target="_blank" class="underline font-bold">Guarda il
          video</a>
        per scoprire di più su Dr.Feel
      </p>
      <p class="font-bold text-drfeel">Hai dubbi o domande?</p>
      <p>
        Per informazioni o supporto in merito all’attivazione o sul servizio,
        contatta Dr.Feel all’indirizzo e-mail
        <a href="mailto:assistenza@drfeel.com" target="_blank" class="underline">assistenza&#64;drfeel.com</a>
      </p>
    </div>
  </div>


</div>